
import Hotjar from '@hotjar/browser';
import { CONSTANTS } from 'src/shared/constants';

if(CONSTANTS.IS_PRODUCTION && process.env.REACT_HOTJAR_SITE_ID && process.env.REACT_HOTJAR_VERSION){
    Hotjar.init(Number(process.env.REACT_HOTJAR_SITE_ID), Number(process.env.REACT_HOTJAR_VERSION));
}  
